var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"grid-list-lg":"","fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }